import { gql } from '@apollo/client';

export const GET_LATEST_COMPATIBLE_VERSION = gql`
  query settingVariables {
    settingsVariables(
      criteria: { pagination: { page: 1, perPage: 100 } }
    ) {
      items {
        latestCompatibleVersion
      }
    }
  }
`;
// Separate from GET_LATEST_COMPATIBLE_VERSION on purpose: if an API without the maintenance
// fields answers, only this query fails and the version check keeps working. perPage differs
// so the two queries do not share (and overwrite) the same un-normalized cache entry.
export const GET_MAINTENANCE = gql`
  query maintenanceSettings {
    settingsVariables(
      criteria: { pagination: { page: 1, perPage: 1 } }
    ) {
      items {
        maintenanceIos
        maintenanceAndroid
        maintenanceWeb
        maintenanceIosBelowVersion
        maintenanceAndroidBelowVersion
      }
    }
  }
`;
